import { createFileRoute } from '@tanstack/react-router'
import { requireActiveSubscription } from '@/lib/middleware'
import { ExtractionExamplesPage } from '@/features/extractions/components/extraction-examples-page'

export const Route = createFileRoute(
  '/_authenticated/_organization/extractions/examples',
)({
  beforeLoad: async () => requireActiveSubscription(),
  component: ExtractionExamplesPage,
})
